import { useEffect, useRef, useState } from 'react';
import * as aserver from '../../APIClient';
import {
    PayPalProvider,
    PayPalOneTimePaymentButton,
    usePayPal,
    INSTANCE_LOADING_STATE,
} from "@paypal/react-paypal-js/sdk-v6";
const axios = require('axios');

const STALL_TIMEOUT_MS = 30000;

const PayPalButtonWrapper = ({ createOrder, onApprove, onCancel, onError, onComplete }) => {
    const { loadingStatus } = usePayPal();

    if (loadingStatus === INSTANCE_LOADING_STATE.PENDING) {
        return <div className="payPalLoading">Loading...</div>;
    }

    return (
        <PayPalOneTimePaymentButton
            createOrder={createOrder}
            onApprove={onApprove}
            onCancel={onCancel}
            onError={onError}
            onComplete={onComplete}
            presentationMode="popup"
        />
    );
};

const PayPal = (props) => {
    const [stalled, setStalled] = useState(false);
    const [retryKey, setRetryKey] = useState(0);
    const stallTimerRef = useRef(null);

    function clearStallTimer() {
        if (stallTimerRef.current) {
            clearTimeout(stallTimerRef.current);
            stallTimerRef.current = null;
        }
    }

    function armStallTimer() {
        clearStallTimer();
        setStalled(false);
        stallTimerRef.current = setTimeout(() => setStalled(true), STALL_TIMEOUT_MS);
    }

    useEffect(() => clearStallTimer, []);

    function retry() {
        clearStallTimer();
        setStalled(false);
        setRetryKey((key) => key + 1);
    }

    async function createOrder() {
        const orderId = localStorage.getItem('checkoutId');
        console.log("[PayPal] createOrder orderId from localStorage:", orderId);
        armStallTimer();
        return { orderId };
    }

    async function onApprove(data) {
        clearStallTimer();
        try {
            let response = (await axios.post(`${aserver.getServerRoot()}${props.paypalCaptureUrl}`, { orderId: data.orderId })).data;
            if (response.error)
                console.log(response.error)
                throw new Error(response.error);
            if (response.success)
                props.onSuccess(data.orderId);
        } catch (error) {
            onError(error);
        }
    }

    function onCancel(data) {
        clearStallTimer();
        console.log("[PayPal] onCancel fired:", data);
        props.onFailure('CANCELLED', 'Transaction cancelled.', data);
    }

    function onError(data) {
        clearStallTimer();
        console.log("There has been a error", data)
        props.onFailure('ERROR', 'Sorry, your transaction could not be processed.', data);
    }

    function onComplete(data) {
        clearStallTimer();
        console.log("Payment session completed:", data);
    }

    return (
        <div>
            <PayPalProvider
                clientId={props.payPalClientId}
                environment={props.payPalEnvironment}
                components={["paypal-payments"]}
                pageType="checkout"
            >
                <br /><br />
                <PayPalButtonWrapper
                    key={retryKey}
                    createOrder={createOrder}
                    onApprove={onApprove}
                    onCancel={onCancel}
                    onError={onError}
                    onComplete={onComplete}
                />
            </PayPalProvider>
            {stalled && (
                <div className="payPalStalled">
                    <p>
                        Still waiting on PayPal? If a sign-in or passkey prompt isn't
                        progressing, it may be stuck in a stale PayPal session.
                    </p>
                    <button type="button" onClick={retry}>Try again</button>
                </div>
            )}
        </div>
    );
};

export default PayPal;
